"use strict";

exports.__esModule = true;
exports.HelpContext = void 0;
var _Utils = require("../../Utils");
var _HelpController = require("./HelpController");
/**
 * Provides (optionally context-sensitive) help across the application.
 *
 * @component
 */
var HelpContext = exports.HelpContext = (0, _Utils.createEnhancedContext)({
  propName: "help",
  defaultController: _HelpController.HelpController
});